import { format } from 'date-fns';
import { Link } from 'react-router-dom';
import ROUTES from '../../../routes/Routes.js';

export default function MultimediaLevelTable({ multimediaLevels, currentPage, itemsPerPage, handleSort, sortField, sortOrder }) {
    return (
        <>
            <table className="table">
                <thead>
                    <tr>
                        <th scope="col">#</th>
                        <th onClick={() => handleSort('name')} style={{ cursor: 'pointer', textDecoration: "underline" }}>Nombre{' '}
                            {sortField === 'name' && (
                                sortOrder === 'asc'
                                    ? <i className="bi bi-caret-up-fill"></i>
                                    : <i className="bi bi-caret-down-fill"></i>
                            )}
                        </th>
                        <th scope="col">Última modificación</th>                            
                        <th scope="col">Descripciones</th>
                        <th scope="col">Acciones</th>
                    </tr>
                </thead>
                <tbody className="table-group-divider">
                    {multimediaLevels?.length === 0 ? (
                        <tr>
                            <td colSpan="5" className="text-center">
                                No hay registros disponibles
                            </td>
                        </tr>
                    ) : (
                        multimediaLevels.map((multimediaLevel, index) => {
                            const rowNumber = (currentPage - 1) * itemsPerPage + index + 1;
                            return (
                                <tr key={multimediaLevel.id}>
                                    <td>{rowNumber}</td>
                                    <td>{multimediaLevel.name}</td>
                                    <td>{format(new Date(multimediaLevel.updatedAt), 'dd-MM-yyyy')}</td>
                                    <td>{multimediaLevel.description}</td>
                                    <td>    
                                        <Link to={`${ROUTES.EDIT_MULTIMEDIA_LEVELS}/${multimediaLevel.id}`} className="btn btn-primary me-md-2"><i className="bi bi-pencil-square"></i></Link>
                                    </td>
                                </tr>
                            );
                        })
                    )}
                </tbody>
            </table>
        </>
    );
}